define('modules/common/module',[
    "modules/common/routes",
    "modules/common/interceptor",
    "modules/common/controller/Dashboard",
    "modules/common/controller/IMieiDati",
    "modules/common/controller/Fascicoli",
    "modules/common/controller/ParentFascicolo",
    "modules/common/controller/Fascicolo",
    "modules/common/controller/FascicoloDocumenti",
    "modules/common/controller/FascicoloImpegni",
    "modules/common/controller/Help",
    "modules/common/controller/Error",
    "modules/common/controller/Router",
    "modules/common/controller/ModalCookie",
    "modules/common/controller/ModalPrivacy",
    "modules/common/controller/ModalTestoMail",
    "modules/common/controller/ModalChangePasswordController",
    "modules/common/controller/ModalNote",
    "modules/common/directive/IfUiSref",
    "modules/common/directive/AppMenu",
    "modules/common/directive/StatusBar",
    "modules/common/directive/CliensAvvisi",
    "modules/common/directive/FooterPanel",
    "modules/common/directive/DocumentFolderNavigation",
    "modules/common/filter/prossimaudienza",
    "modules/common/filter/curia",
    "modules/common/filter/responsabile",
    "modules/common/filter/notaPreview",
    "modules/common/filter/nl2br",
    "modules/common/service/Studio",
    "modules/common/service/Token",
    "modules/common/service/DatiCliente",
    "modules/common/service/ListaFascicoli",
    "modules/common/service/LoadingHandler",
    "modules/common/service/RiferimentiStudio",
    "modules/common/service/DettagliFascicolo",
    "modules/common/service/DocumentiFascicolo",
    "modules/common/service/DownloadDocumento",
    "modules/common/service/LocalStorage",
    "modules/common/service/Analytics",
    "modules/common/service/InvioMail",
    "modules/common/service/CambiaPassword"
], function(
    Routes,
    Interceptor,
    DashboardController,
    IMieiDatiController,
    FascicoliController,
    ParentFascicoloController,
    FascicoloController,
    FascicoloDocumentiController,
    FascicoloImpegniController,
    HelpController,
    ErrorController,
    RouterController,
    ModalCookieController,
    ModalPrivacyController,
    ModalTestoMailController,
    ModalChangePasswordController,
    ModalNoteController,
    IfUiSref,
    AppMenu,
    StatusBar,
    CliensAvvisi,
    FooterPanel,
    DocumentFolderNavigation,
    prossimaudienza,
    curia,
    responsabile,
    notaPreview,
    nl2br,
    Studio,
    Token,
    DatiCliente,
    ListaFascicoli,
    LoadingHandler,
    RiferimentiStudio,
    DettagliFascicolo,
    DocumentiFascicolo,
    DownloadDocumento,
    LocalStorage,
    Analytics,
    InvioMail,
    CambiaPassword
) {
    "use strict";
    var MODULE_NAME = "Common";
    angular.module(MODULE_NAME, ["Constants", "ui.router", "ngSanitize", "uuid4", "toaster"])

    .run(['$window', 'ANALYTICS', function($window, ANALYTICS) {
        $window._gaq = $window._gaq || [];
        $window._gaq.push(['_setAccount', ANALYTICS.ANALYTICSUACODE]);
        $window._gaq.push(['_setDomainName', 'cliens.it']);
        var ga = document.createElement('script');
        ga.type = 'text/javascript';
        ga.async = true;
        ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(ga, s);

    }])

    .directive("ifUiSref", IfUiSref)
        .directive("appMenu", AppMenu)
        .directive("statusBar", StatusBar)
        .directive("cliensAvvisi", CliensAvvisi)
        .directive("footerPanel", FooterPanel)
        .directive("documentFolderNavigation", DocumentFolderNavigation)
        .filter("prossimaudienza", prossimaudienza)
        .filter("curia", curia)
        .filter("responsabile", responsabile)
        .filter("notaPreview", notaPreview)
        .filter("nl2br", nl2br)
        .controller("DashboardController", DashboardController)
        .controller("IMieiDatiController", IMieiDatiController)
        .controller("FascicoliController", FascicoliController)
        .controller("ParentFascicoloController", ParentFascicoloController)
        .controller("FascicoloController", FascicoloController)
        .controller("FascicoloDocumentiController", FascicoloDocumentiController)
        .controller("FascicoloImpegniController", FascicoloImpegniController)
        .controller("HelpController", HelpController)
        .controller("ErrorController", ErrorController)
        .controller("RouterController", RouterController)
        .controller("ModalCookieController", ModalCookieController)
        .controller("ModalPrivacyController", ModalPrivacyController)
        .controller("ModalTestoMailController", ModalTestoMailController)
        .controller("ModalChangePasswordController", ModalChangePasswordController)
        .controller("ModalNoteController", ModalNoteController)
        .service("Studio", Studio)
        .service("Token", Token)
        .service("DatiCliente", DatiCliente)
        .service("ListaFascicoli", ListaFascicoli)
        .service("LoadingHandler", LoadingHandler)
        .service("RiferimentiStudio", RiferimentiStudio)
        .service("DettagliFascicolo", DettagliFascicolo)
        .service("DocumentiFascicolo", DocumentiFascicolo)
        .service("DownloadDocumento", DownloadDocumento)
        .service("LocalStorage", LocalStorage)
        .service("Analytics", Analytics)
        .service("InvioMail", InvioMail)
        .service("CambiaPassword", CambiaPassword)
        .config(Interceptor)
        .config(Routes);

    return MODULE_NAME;
});
